import { useDispatch } from 'react-redux';
import { Button, DialogActions, DialogContent, DialogTitle, type DialogProps } from '@mui/material';

import { closeDialog, openDialog } from 'app/store/fuse/dialogSlice';
import useSettings from '../hooks/useSettings';

interface DialogGenericInfoProps {
	/** The dialog title component */
	title?: React.ReactNode;
	/** The dialog content component */
	content?: React.ReactNode;
	/** Function called to close the dialog */
	onClose?: VoidFunction;
	/** Props used on the dialog */
	dialogProps?: Omit<DialogProps, 'open'>;
}

export const showDialogGenericInfo = ({ dialogProps = {}, ...props }: DialogGenericInfoProps) =>
	openDialog({ children: <DialogGenericInfo {...props} />, ...dialogProps });

export default function DialogGenericInfo({ title, content, onClose }: Omit<DialogGenericInfoProps, 'dialogProps'>) {
	const dispatch = useDispatch();
	const { t } = useSettings();

	const close = () => (onClose ? onClose() : dispatch(closeDialog()));

	return (
		<>
			{title && <DialogTitle>{title}</DialogTitle>}
			{content && <DialogContent>{content}</DialogContent>}
			<DialogActions>
				<Button onClick={close}>{t('DIALOG_ACTION_CLOSE')}</Button>
			</DialogActions>
		</>
	);
}
